module.exports = __webpack_public_path__ + "img/i_care_logo_large.032fab97.png";